import {
  generateSearchQuery,
  GenerateSearchQueryOptions,
  parseSearchQuery,
  ParseSearchQueryOptions,
  queryAPI,
} from '@cutwise/utils';

import { addPrefixToHost } from '@/common/helpers/addPrefixToHost';
import config from '@/config';
import { NETBOX_ORIGIN } from '@/netbox/constants/network';

export default class URLBuilder {
  static params() {
    return { ...queryAPI.params };
  }

  static hash() {
    return queryAPI.hash;
  }

  static path() {
    return `${window.location.pathname}${queryAPI.query}`;
  }

  static build(base: string, path: string, params: Record<string, unknown>) {
    let baseValue = base.trim();
    let pathValue = path.trim();

    if (baseValue?.endsWith('/')) {
      baseValue = baseValue.slice(0, baseValue.length - 1);
    }

    if (pathValue?.startsWith('/')) {
      pathValue = pathValue.slice(1, pathValue.length);
    }

    return `${baseValue}/${pathValue}${URLBuilder.buildQueryString(params)}`;
  }

  static buildUrl(path: string, params: Record<string, unknown>, prefix = 'api') {
    let base = config.API_HOST || window.location.origin;

    if (!base.includes(NETBOX_ORIGIN)) {
      base = addPrefixToHost(prefix);
    }

    return URLBuilder.build(base, path, params);
  }

  static buildQueryString(params: Record<string, Any>, options: GenerateSearchQueryOptions = {}) {
    return generateSearchQuery(params, { encode: true, ...options });
  }

  static parseQueryString(search: string, options: ParseSearchQueryOptions = {}) {
    return parseSearchQuery(decodeURIComponent(search), options);
  }

  static replace(path: string) {
    window.history.replaceState({}, '', path);
  }

  static replaceQuery(params: Record<string, Any>) {
    window.history.replaceState({}, '', `${window.location.pathname}${URLBuilder.buildQueryString(params)}`);
  }

  static toAbsoluteUrl(path: string) {
    return `${window.location.origin}${path}`;
  }
}
